<template>
   <div class="menu-search" :class="{'menu-search-col': isCollapse}">
        <div :title="isCollapse ? '' : $t('newHome.t1')">
            <md-input
                v-model="val"
                :placeholder="isCollapse ? '' : $t('newHome.t1')"
                clearable
                @clear='clear'
                @input="handleInput"
                @focus="focus"
                @blur="blur"
            >
                <i slot="prefix" class="md-icon-search md-input__icon" @click="handleIconClick"></i>
            </md-input>
        </div>
        <div class="search-popover" :class="{'search-popover-hide': !popoverVisible}">
            <ul class="menu-box">
                <li v-for="item in searchMenuList" :key="item.fdId" class="menu-item" @click="goRouter(item.item)">
                    <div class="menu-item-title-box">
                        <p class="menu-item-title" v-html="item.fdName"></p>
                        <p v-if="item.subFdName" class="menu-item-title menu-item-path" :title="item.subTitle" v-html="item.subFdName"></p>
                    </div>
                    <p class="menu-item-path">{{ item.path }}</p>
                </li>
            </ul>
        </div>
        <!-- 菜单折叠时，点击搜索的弹出框 -->
        <div v-if="inputDraVisible" class="menu-search menu-search-dra">
            <md-input
                v-model="valDra"
                class="input-dra"
                :placeholder="$t('newHome.t1')"
                clearable
                autofocus
                @clear='clear'
                @input="handleInput"
                @focus="focus"
                @blur="blur"
            >
                <i slot="prefix" class="md-icon-search md-input__icon"></i>
            </md-input>
            <span class="cancel" @click='cancelDra'>{{$t('common.close')}}</span>
        </div>
    </div>
</template>
<script>
import { ConvertPinyin } from '@/utils/pinyin.js';
import _ from 'lodash';

export default {
    name: 'MenuSearch',
    data() {
        return {
            val: '',
            valDra: '', // 折叠时输入弹框的值
            popoverVisible: false,
            inputDraVisible: false,
            searchMenuList: [],
        };
    },
    props: {
        isCollapse: {
            type: Boolean,
            default: false,
        },
        menus: {
            type: Array,
            default: () => ([]),
        },
    },
    watch: {
        isCollapse() {
            this.val = '';
            this.cancelDra();
        },
    },
    methods: {
        clear() {
            this.popoverVisible = false;
        },
        focus() {
            if (this.val || this.valDra) {
                this.popoverVisible = true;
            }
        },
        blur() {
            // 延迟关闭，防止点击搜索结果时，弹出框消失
            setTimeout(() => {
                this.popoverVisible = false;
            }, 300);
        },
        cancelDra() {
            this.inputDraVisible = false;
            this.valDra = '';
            this.popoverVisible = false;
        },
        handleIconClick() {
            // 折叠时才作用
            if (!this.isCollapse) return;
            this.inputDraVisible = true;
            // 自动获取焦点
            this.$nextTick(() => {
                console.log(document.querySelector('.input-dra'));
                const inputDom = document.querySelector('.input-dra');
                inputDom.querySelector('.md-input__inner').focus();
                console.log(inputDom.querySelector('.md-input__inner'));
            });
        },
        // eslint-disable-next-line func-names
        handleInput: _.debounce(function (value) {
            if (value) {
                this.popoverVisible = true;
                this.searchMenuList = this.getSearchMenuList(value);
            } else {
                this.popoverVisible = false;
                this.searchMenuList = [];
            }
        }, 200),
        getSearchMenuList(value) {
            const val = value.toLowerCase();
            const res = [];
            this.menus.forEach((item) => {
                item.subNodes?.forEach((item2) => {
                        const title = ConvertPinyin(item2.fdName || ''); // 标题

                        // 拆分副标题与标题描述
                        const desArr = item2.fdDescription?.split('@') || [];
                        const fdDescription = desArr[0] || ''; // 标题描述
                        const subTitle = desArr[1] || ''; // 副标题
                        const fdDesPinyin = ConvertPinyin(fdDescription);  // 描述拼音
                        const subTitlePinyin = ConvertPinyin(subTitle);  // 副标题拼音

                        if (item2.fdName?.toLowerCase().includes(val) || title.toLowerCase().includes(val) || fdDescription.toLowerCase().includes(val) || fdDesPinyin.toLowerCase().includes(val) || subTitle.toLowerCase().includes(val) || subTitlePinyin.toLowerCase().includes(val)) {
                            // 设置高亮字段
                            const pattern = new RegExp(`(${value})`);
                            const fdName = item2.fdName.replace(pattern, '<span class="highlight">$1</span>');
                            const subFdName = subTitle ? (`（${subTitle}）`).replace(pattern, '<span class="highlight">$1</span>') : '';
                            res.push({
                                item: item2,
                                fdName,
                                subFdName,
                                subTitle,
                                fdId: item2.fdId,
                                path: `${item.fdName}/${item2.fdName}`, // 路径
                            });
                        }
                });
            });
            return res;
        },
        goRouter(item) {
            this.$emit('disableEnter', true);
            this.cancelDra();
            this.$emit('goRouter', item.fdFrontLink, item);
        },
    },
};
</script>
<style lang='less' scoped>
@import url("../../../../../styles/vars.less");
.menu-search {
    position: relative;
    padding: 6px 12px;
    margin-bottom: 6px;
    height: @header-height;
    .md-icon-circle-close {
        cursor: pointer;
    }
    .search-popover {
        overflow-y: auto;
        // transition: all 0.1s ease-in; // 取消动画
        position: fixed;
        top: @header-height*2 - 2;
        min-height: 54px;
        max-height: 80vh;
        background: #FFFFFF;
        border-radius: 2px;
        box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 5px -4px rgba(0,0,0,0.12);
        z-index: 999;
        .menu-box {
            width: 100%;
            .menu-item {
                padding: 7px 12px;
                margin: 4px 0;
                width: 100%;
                height: 54px;
                white-space: nowrap;
                &:hover {
                    cursor: pointer;
                    background: #F4F6F8;
                }
                .menu-item-title-box {
                    display: flex;
                    align-items: flex-end;
                    .menu-item-title {
                        font-weight: 400;
                        font-size: 14px;
                        color: #212B36;
                        /deep/.highlight {
                            color: @default-blue;
                        }
                    }
                    .menu-item-path {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                .menu-item-path {
                    font-size: 12px !important;
                    color: #919EAB !important;
                }
            }
        }
    }
    .search-popover-hide {
        display: none;
    }
}
.menu-search-col {
    .md-icon-search {
        cursor: pointer;
    }
    /deep/.md-input--suffix .md-input__inner{
        padding-right: 0px;
    }
}

// 折叠时，弹出搜索框
.menu-search-dra {
    position: fixed;
    padding: 12px;
    height: auto;
    top: @header-height;
    left: @leftSidebar-width-col;
    box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05), 0px 6px 16px 0px rgba(0,0,0,0.08), 0px 3px 5px -4px rgba(0,0,0,0.12);
    background: #FFFFFF;
    .input-dra {
        width: 80%;
    }
    .cancel {
        cursor: pointer;
        margin-left: 4px;
    }
}

</style>